import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import auth from '../../../helpers/auth';

export class SavedView extends React.Component {
  constructor(props) {
    super(props);
    // if (auth.isAuthenticated) {
    //   this.props.history.push("/connect/home");
    // }
  }
  redirectToDashboard() {
    window.location.href = '/coach/dashboard';
  }
  render() {
    return (
      <Fragment>
        <div className="main-content yss-site--main__content">
          <div className="site__content">
            <div className="page__content">
              <div className="form__heading">
                <h3>
                  Thank <span>You For Signing Up!</span>
                </h3>
              </div>
              <div className="site__form middle__content add-listing--form">
                <div className="form-item form-item--login__required">
                  <span>
                    Listing submitted successfully. Your listing will be visible
                    once it has been approved.
                  </span>
                  <br />
                  <span>
                    Please complete your profile, click{' '}
                    <Link
                      to="#"
                      className="text_nav_blue"
                      onClick={() => this.redirectToDashboard()}
                    >
                      {' '}
                      go to your dashboard
                    </Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/AddListings/components/SavedView.js